export default __webpack_public_path__ + "./images/ja.08714d17.png";